import { z } from "zod";

export const createCorrectiveVehicleRestitutionPayload = z.object({
  driverUuid: z.uuid(),
  mileage: z.number(),
  isCabinCleaned: z.boolean(),
  isTrunkCleaned: z.boolean(),
  observations: z.string().nullable(),
  initialRestitution: z.uuid(),
  initialPicturesToKeep: z.array(z.uuid()),
  picturesToUpload: z.array(
    z.object({
      originalFileName: z.string(),
      fileBuffer: z.string(),
    }),
  ),
});

export type CreateCorrectiveVehicleRestitutionPayload = z.infer<
  typeof createCorrectiveVehicleRestitutionPayload
>;
